const className = "scrolled";
const scrollTrigger = 1;

export default () => {
// We add pageYOffset for compatibility with IE.
    if (window.scrollY >= scrollTrigger || window.pageYOffset >= scrollTrigger) {
    document.getElementsByTagName("body")[0].classList.add(className);
    } else {
        document.getElementsByTagName("body")[0].classList.remove(className);
    }
};

